<template>
    <div>
        <PageTop></PageTop>
        <div>
            <div class="my-12 flex justify-around">
                <button @pointerup="logout"
                class="bg-bd px-4">退出登录</button>
                <button @pointerup="getData"
               class="bg-bd px-4" >刷新</button>
            </div>
            <table class="text-14 w-full text-center">
                <thead>
                    <tr>
                        <td>保岗</td>
                        <td>题目</td>
                        <td>答案</td>
                        <td>场次</td>
                        <td>状态</td>
                        <td>日期</td>
                        <td>操作</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in list" :key="item.id" :class="{'bg-red-300':item.status === 2}"
                    >
                        <td>{{item.baodi}}</td>
                        <td class="w-100">{{item.text}}</td>
                        <td>{{imgName?.[item.result - 1]}}</td>
                        <td>{{item.times}}</td>
                        <td>{{item.status === 1 ? '未开奖' : '已开奖'}}</td>
                        <td>{{moment(item.joinin).format('YYYY-MM-DD') }}</td>
                        <td>
                            <button v-if="item.status === 1" class="bg-bd text-bg" @pointerup="startChange(item.id)">修改</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <!-- 修改 -->
         <div v-if="flage" class="w-300 text-16 p-4 border-2 border-solid border-bd bg-bg fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-[2px_2px_2px_#ccc]" >
            <div>{{ moment(change.joinin).format('YYYY-MM-DD') }} 第{{ change.times }}场</div>
            <label>保岗：</label>
            <input v-model="change.baodi" type="text" class="text-16 text-center w-200 border-1 border-solid border-bd">
            <button class="ml-2 text-14 px-2 py-1 bg-bd text-bg" @pointerup="randomBaogang">随机</button><br>
            <label>题目：</label><input v-model="change.text" type="text" class="text-16 text-center w-200 border-1 border-solid border-bd"><br>
            <label>结果：</label>
            <select v-model="change.result">
                <option v-for="(item,index) in imgName" :key="index" :value="index + 1">{{ item }}</option>
            </select>
            <div class="flex justify-around my-8">
                <button class="text-16 px-4 bg-bd text-bg" @pointerup="flage = false">取消</button>
                <button class="text-16 px-4 bg-bd text-bg" @pointerup="config">确认</button>
            </div>
         </div>
    </div>
</template>
<script>
import PageTop from '@/components/PageTop.vue';
import moment from 'moment';

export default{
    components:{
        PageTop
    },
    data(){
        return{
            imgName: [
                '白鱼','白马','蝴蝶','金龙','野猫','和尚','鸡','金鱼','马鹿',
                '仙鹤','乌龟','乌鸦','大象','蜘蛛','蛇','孔雀','老虎','鹅',
                '红燕','猴子','猪','螺蛳','狗','兔子','飞龙','家猫','螃蟹',
                '牛','羊','蚯蚓','鸽子','青蛙','宝石','蜜蜂','黄鳝','老鼠'
            ],  
            list:'',
            change:'',
            flage : false,
            recentRandomBaogang: []
        }
    },
    mounted(){
        this.getData()
    },
    methods:{
        logout(){
            localStorage.removeItem('token')
            this.$router.push({name:'adminLogin'})
        },
        async startChange(id){
            const target = this.list.filter(item => item.id === id)
            console.log(target);
            
            this.change = {
                baodi : target[0].baodi,
                text : target[0].text,
                result:target[0].result,
                joinin:target[0].joinin,
                times:target[0].times,
                id:target[0].id
            }
            console.log(this.change);
            
            this.flage = true
        },
        async config(){
            const token = localStorage.getItem('token')
            try{
                const res = await this.$axios.post('/admin/changeGame',{
                    baodi:this.change.baodi,
                    id:this.change.id,
                    text:this.change.text,
                    result:this.change.result
                },
                {
                    headers:{
                        Authorization:`Bearer ${token}`
                    }
                })
                console.log(res);
                alert('更新成功')
                this.getData()
                this.flage = false
            }catch(err){
                console.error(err);
                if(err.response.status === 401){
                    alert('重新登录')
                     this.$router.push({name:'adminLogin'})
                }
            }
        },
        async randomBaogang(){
            const token = localStorage.getItem('token')
            const exclude = [
                this.change.baodi,
                ...this.recentRandomBaogang,
                ...this.list.map(item => item.baodi)
            ].filter(Boolean)

            try{
                const res = await this.$axios.post('/admin/random-baogang', { exclude }, {
                    headers:{
                        Authorization:`Bearer ${token}`
                    }
                })
                const baodi = res.data?.data?.baodi
                if(!baodi){
                    throw new Error('随机保岗为空')
                }
                this.change.baodi = baodi
                this.recentRandomBaogang = [baodi, ...this.recentRandomBaogang].slice(0, 20)
            }catch(err){
                console.error(err)
                if(err.response?.status === 401){
                    alert('重新登录')
                    return this.$router.push({name:'adminLogin'})
                }
                alert('随机保岗生成失败，请重试')
            }
        },
        async getData(){
            const token = localStorage.getItem('token')
            try{
                const now = moment()
                console.log(now);
                
                const res = await this.$axios.get('/admin/getList',
                    {
                        headers:{
                            Authorization:`Bearer ${token}`
                        }
                    }
                )
                this.list = res.data?.data
                alert('数据获取成功')
            }catch(err){
                if(err.response.status === 401){
                    alert('重新登录')
                    return this.$router.push({name:'adminLogin'})
                }
                alert('更改失败请重试')
            }
        }
    }
}
</script>
<style scoped>
td{
    border: 1px solid #C5A059;
}
</style>
